// src/services/TermsService.js
import api from './Api';

const BASE_URL = 'tools/';

export default {
  getBrandsFromUrl: (url, geo) => {
    return api.get(`${BASE_URL}toplist-scraper`, {
      params: {
        url,
        geo
      }
    });
  },
  getSuggestedBrands: (brands, geo) => {
    return api.post(`${BASE_URL}suggested-brands`, {
      brands,
      market: geo
    });
  }
};